export default __webpack_public_path__ + "static/media/04-min.1c72dec6.jpg";